module.exports = __webpack_public_path__ + "img/login_logo.f7c0ee85.png";